import { COUNTRY_NAMES } from '@constants/countries';

export const getCompanyAddress = (address, city) => {
    if (!address && !city) {
        return '--';
    }
    return `${address}${city ? `, ${city}` : ''}`;
};

export const getCompanyFullAddress = company => {
    const addr1 = company.addressLine1 || '';
    const addr2 = company.addressLine2 || '';
    const city = company.city || '';
    const postalCode = company.postalCode || '';
    return `${addr1}${addr2 ? `, ${addr2}` : ''}${city ? `, ${city}` : ''}${postalCode ? `, ${postalCode}` : ''}`;
};

export const generateCompanyCardAddress = addr => {
    return `${addr.addressLines[0] || ''}, ${addr.city || ''}, ${addr.postalCode || ''}, ${
        COUNTRY_NAMES[addr.country] || ''
    }`;
};
